const getters = {
	// Проверка аутентификации
	checkAuthGetters: (state: { checkAuthState: object }) => state.checkAuthState,

	// Проверяем, зарегистрирован номер или нет.
	checkRegisteredGetters: (state: { checkRegisteredState: object }) =>
		state.checkRegisteredState,

	// Генерация проверочного кода
	loginConfirmationCodeGetters: (state: {
		loginConfirmationCodeState: object;
	}) => state.loginConfirmationCodeState,

	// Выход из системы
	logoutGetters: (state: { logoutState: object }) => state.logoutState,
};
export default getters;
